<template>
  <div class="support-setting-edit relative">
    <menu-item label="服务系统">
      <im-select v-model="model.type" class="w-full" target-key="type" size="small" :options="CustomerServiceSystemEnum" clearable placeholder="请选择服务厂商" />
    </menu-item>
    <menu-item label="悬浮按钮">
      <menu-switch v-model="model.floatEnabled" target-key="floatEnabled" label="显示" />
    </menu-item>
    <menu-item label="布局">
      <im-select v-model="model.layout" target-key="layout" class="w-full"  size="small" :options="CustomerLayoutOptionsEnum" />
    </menu-item>
    <menu-item label="LOGO图片">
      <menu-background-image :target="model.logo" :eye-key="null" target-key="logo" />
    </menu-item>
  </div>
</template>

<script>
import ImSelect from '~/components/common/ImSelect.vue'
import MenuItem from '~/components/menu/menuItem.vue'
import { CustomerServiceSystemEnum, CustomerLayoutOptionsEnum } from '~/enums/data'
import MenuSwitch from '~/components/menu/menuSwitch.vue'
import MenuBackgroundImage from '~/components/menu/menuBackgroundImage.vue'

export default {
  components: {
    MenuBackgroundImage,
    MenuSwitch,
    MenuItem,
    ImSelect
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      CustomerServiceSystemEnum,
      CustomerLayoutOptionsEnum
    }
  }
}
</script>

<style lang="less"></style>
